// extracted by mini-css-extract-plugin
export default {"main":"cedy9","text":"sHceA"};